<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

defineOptions({
    inheritAttrs: false,
});

interface Props {
    className?: HTMLAttributes['class'];
    iconOnly?: boolean;
}

withDefaults(defineProps<Props>(), {
    iconOnly: false,
});
</script>

<template>
    <img
        v-if="iconOnly"
        src="/T-icon.png"
        alt="Tourium"
        width="152"
        height="167"
        class="h-6 w-auto shrink-0 object-contain"
        :class="className"
        v-bind="$attrs"
    />
    <!--
        tourium-logo-header.png is the wordmark at 96px tall: twice the largest
        size it is drawn at (lg:h-12), so it stays crisp on high-density screens
        without shipping the 895×345 master. The intrinsic width/height reserve
        the box before the bytes arrive, which is what keeps it out of CLS.
    -->
    <img
        v-else
        src="/tourium-logo-header.png"
        alt="Tourium - AI Driven Travel Solutions"
        width="249"
        height="96"
        class="h-10 w-auto shrink-0 object-contain"
        :class="className"
        v-bind="$attrs"
    />
</template>
